import React, { Component } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';

import { translate } from 'react-i18next';
import { asyncConnect, reducer as reduxAsyncConnect } from 'redux-connect';


import { isLoaded, load as loadGroups } from 'redux/modules/groups';

import { CreateGroupForm } from 'components';
@asyncConnect([{

  promise: ({ store: { dispatch, getState }, params }) => {
    //if (!isLoaded(getState())) {
    return dispatch(loadGroups(params));
    //}
  }
}])
@translate(['common'])
export default class AddGroup extends Component {
  render() {
    const {
      t,
    } = this.props;

    const styles = require('./AddGroup.scss');

    return (
      <div className={styles.loginPage + ' container'}>
        <Helmet title={t('main.create_a_group')} />
        <h1>{t('main.create_a_group')}</h1>
        <CreateGroupForm urlParams={this.props.params} formKey="createGroupForm1" />
      </div>
    );
  }
}
